<template>
  <div class="u-input custom-price-input" :class="[$vs.rtl ? 'dir-rtl' : 'dir-ltr']">
    <div class="u-input-box" :class="[{'is-not-valid': !price.isValid || inValid, 'disabled': disabled, 'force-value': forceValue, 'has-checkbox': price.hasOwnProperty('checked')}, classes || {}]" :style="getStyles">
<!--      <span class="input-label" :class="{'is-focus': price.value.toString().length || label.length}">{{ labelPlaceholder || label }}</span>-->
      <div class="u-input-label-box">
        <div class="u-input-label-box-start"></div>
        <div v-if="labelPlaceholder || label" class="u-input-label-box-center" :class="[labelPosition]">
          <span class="u-input-label text-subtitle" :class="[{'is-focus': price.value.toString().length || label, 'text-body-1': labelPosition === 'inside'}]">{{ labelPlaceholder || label }}</span>
        </div>
        <div class="u-input-label-box-end"></div>
      </div>
      <div class="u-input-price-box" :class="{'disabled': price.checked}">
        <div v-if="disabled || price.checked"
             class="disable-input-value disabled"
             @click="handleClickInput">
          {{ price.value }}
        </div>
        <input type="text"
               v-else
               id="priceInput"
               ref="priceInput"
               :class="[{'disabled': disabled, 'force-value': forceValue}]"
               :style="inputStyle"
               inputmode="decimal"
               @input="handleInputValue"
               @contextmenu="handleContextMenuClicked($event)"
               @keydown.enter="handleKeydownEnter"
               @focus="event => $emit('focus', event)"
               @click="handleClickInput"
               :autocomplete="'new-password'"
               :name="Math.random()"
               :placeholder="placeholder || value.placeholder || ''"
               :disabled="disabled"
               v-model="price.value">
        <span class="input-currency" @click="handleClickCurrency">{{ currency || $u.locale.currency() }}</span>
        <button v-if="price.value.length > 0 && !disabled && clearable && !forceValue" class="clear-btn" @click="handleClearInput">
          <custom-icon icon="TIMES" color="danger" height="20px" width="20px" />
        </button>
      </div>

      <div v-if="price.hasOwnProperty('checked')" class="u-input-checkbox-box">
        <u-checkbox :label="checkboxLabel || $t('global.free')" :disabled="disabled" v-model="price.checked" @checked="price.value = '', handleInputValue()" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable prefer-const */
import CustomIcon from '../icon/customIcon'
import UCheckbox from '../checkBox/UCheckbox.vue'

export default {
  name: 'customPriceInput',
  components: {UCheckbox, CustomIcon},
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    checkboxLabel: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    labelPlaceholder: {
      type: String,
      default: ''
    },
    labelPosition: {
      type: String,
      default: 'outline',
      validator (value) {
        return ['outline', 'outside'].includes(value)
      }
    },
    isEmpty: {
      type: Boolean,
      default: true
    },
    inValid: {
      type: Boolean,
      default: false
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    forceValue: {
      type: Boolean,
      default: false
    },
    hasDigit: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default () {
        return {}
      }
    },
    currency: {
      type: String,
      default: ''
    },
    classes: {
      type: [Object, Array, String],
      default () {
        return {}
      }
    },
    styles: {
      type: Object,
      default () {
        return {}
      }
    },
    max: {
      type: [Number, String],
      default: () => 0
    },
    inputStyle: {
      type: String,
      default () {
        return ''
      }
    }
  },
  data () {
    return {
      price: {
        value: '',
        isValid: false
      }
    }
  },
  computed: {
    getStyles () {
      const styles = JSON.parse(JSON.stringify(this.styles))
      if (!styles.width) {
        // styles.width = '230px'
      }

      return styles
    }
  },
  created () {
    if (Object.keys(this.value).length) {
      this.initValues()
    }
    this.validateValue()

    setTimeout(() => {
      if (this.autoFocus) {
        let priceInput = window.document.getElementById('priceInput')
        if (priceInput) {
          priceInput.focus()
        }
      }
    }, 100)

  },
  methods: {
    handleInputValue () {
      if (this.forceValue) {
        this.price.value = this.value.value
      } else {
        this.addComma()
        this.validateValue()
        let emitValue = {value: this.price.value.split(',').join(''), placeholder: this.value.placeholder, isValid: this.price.isValid}
        if (this.price.hasOwnProperty('checked')) {
          emitValue.checked = this.price.checked
        }
        this.$emit('input', emitValue)
      }
    },
    handleClearInput () {
      if (!this.forceValue) {
        // this.price.value = ''

        let emitValue = {value: '', placeholder: this.value.placeholder, isValid: this.price.isValid}
        if (this.price.hasOwnProperty('checked')) {
          emitValue.checked = this.price.checked
        }
        this.$emit('input', emitValue)
      }
    },
    validateValue () {
      if (this.isEmpty && this.price.value === '') {
        this.price.isValid = true
      } else if (this.max > 0) {
        this.price.isValid = this.$u.parseFloat(this.value.value || '0') <= this.max
      } else {
        this.price.isValid = this.price.value.toString().length > 0
      }
    },
    addComma () {
      this.price.value = this.$u.priceFormat(this.price.value, false, this.hasDigit)
    },
    initValues () {
      this.price.value = this.value.value !== null ? this.$u.priceFormat(this.value.value, false, this.hasDigit) || '' : ''
      this.price.isValid = this.value.isValid
      if (this.value.hasOwnProperty('checked')) {
        this.price.checked = this.value.checked
      }
      this.validateValue()
    },
    handleContextMenuClicked (event) {
      const payload = {
        actions: {
          clipboard: this.price.value,
          paste: true
        },
        event
      }
      this.$store.dispatch('helper/contextMenuClicked', payload)
    },
    handleClickInput () {
      this.$emit('clicked')
    },
    handleKeydownEnter () {
      this.$emit('pressEnter')
    },
    handleClickCurrency () {
      const inputEl = this.$refs.priceInput
      if (inputEl) {
        inputEl.focus()
      }
    }
  },
  watch: {
    value: {
      handler () {
        this.initValues()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-price-input {
  position: relative;
  margin: 15px 0 25px;

  .u-input-box {
    transition: all .3s ease;

    &.is-not-valid {
      border-color: #b00000;
      color: #b00000;

      input {
        color: #b00000;
      }
    }

    .u-input-price-box {
      display: flex;
      flex: 1;
      padding: 0 10px 0 5px;
      position: relative;

      &.disabled {
        background-color: var(--u-input-bg-disable);
      }
    }

    .input-currency {
      position: absolute;
      padding: 0 5px;
      -webkit-transition: all .3s ease;
      -moz-transition: all .3s ease;
      -o-transition: all .3s ease;
      -ms-transition: all .3s ease;
      transition: all .3s ease;
      top: 50%;
      right: 5px;
      transform: translateY(-50%);
    }

    input,
    .disable-input-value {
      display: inline-flex;
      width: calc(100% - 40px);
      background: transparent;
      border: none;
      outline: none !important;
      direction: rtl;

      &.disabled {
        opacity: 0.75;
      }

      &.force-value {
        caret-color: transparent;
      }
    }
  }

  .clear-btn {
    position: absolute;
    top: calc(100% / 2 - 8px);
    left: 5px;
    height: 20px;
    width: 20px;
    border: 0;
    background-color: inherit;

    &:hover {
      cursor: pointer;
    }

    .icon-component {
      position: relative;
      right: 5px;
      top: -2px;
    }
  }

  &.dir-ltr {
    .u-input-box {
      input,
      .disable-input-value {
        direction: ltr;
        text-align: left;
      }
    }

    .clear-btn {
      right: 0;
      left: unset;

      .icon-component {
        right: 0;
      }
    }
  }
}
</style>
